/* eslint-disable react/sort-comp */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NumberFormat from 'react-number-format';
import { Print } from '@material-ui/icons';
import ReactToPrint from 'react-to-print';
import moment from 'utils/moment';
import SectionHeader from '../../../components/sectionHeader';
import HeaderBack from '../../../components/headerBack/HeaderBack';
import Panel from '../../../components/panel';
import Loading from '../../../components/loading';
import icon from '../../../icons/invoice.png';
import Button from '../../../components/button/button';
import styles from './invoiceDetails.module.scss';
import tableStyles from '../../../styles/general.module.scss';
import { fetchInvoiceDetail, exportInvoice, invoiceGetSchema } from '../redux/actions';
import { renderInfoForType } from '../../../utils/helpers';
import { getTaxAmount, getItemAmount, getallTaxAmount, getallPrices, getTotalAmount, getTotalPaymentAmount,
   getallFeeAmount } from '../components/calculations';
import scissorIcon from '../../../icons/SCISSOR-MENU-ICON-.png';

class InvoiceDetails extends Component {
  options = {
    0: {
      name: 'New'
    },
    1: {
      name: 'Payment Pending'
    },
    2: {
      name: 'Paid'
    },
    3: {
      name: 'Overdue'
    }
  };

  constructor(props) {
  super(props);
  this.state = {
    loadingStatus: false,
    actionDropdown: false
  };
  this.printCustomTemplateRef = React.createRef();
  this.printCustomTemplateRef2 = React.createRef();
  }

  componentDidMount() {
    const { actionGetInvoice, match: { params: { id } }, actionGetSchema } = this.props;
    actionGetInvoice(id);
    actionGetSchema();
  }

  handleExportPDF = (id) => {
    const { actionExportInvoice, invoiceDetail } = this.props;
    let custom_fields = [];
    const invoiceSchema = invoiceDetail?.schema?.schema?.fields || [];
    if (invoiceSchema?.length > 0 && invoiceDetail?.response
      && Object.keys(invoiceDetail?.response)?.length > 0) {
        invoiceSchema.forEach((ele) => {
          if (ele.type === 'multiselect') {
            const v1 = [];
            const f = invoiceSchema.find(x => x.id === ele.id);
            if (invoiceDetail.response[ele.id]) {
              invoiceDetail.response[ele.id].forEach((val) => {
                const value = f.values.find(x => x.key === val)?.value;
                if (value !== undefined) {
                  v1.push(value);
                }
              });
            }
            custom_fields.push({ id: ele.title, data: v1, type: ele.type });
          } else if (ele.type === 'select') {
          const f = invoiceSchema.find(x => x.id === ele.id);
          const val = invoiceDetail.response[ele.id] && f.values.find(x => x.key === invoiceDetail.response[ele.id])?.value;
          custom_fields.push({ id: ele.title, data: val, type: ele.type });
        } else if (ele.type === 'attachments') {
          let attachment_fields=[];
          invoiceDetail.response[ele.id].map(k => attachment_fields.push({ data: k.url, filename: k.file_name, content_type: k.content_type }));
          custom_fields.push({ id: ele.title, data: attachment_fields, type: ele.type });
        } else {
          custom_fields.push({
            id: ele.title,
            data: renderInfoForType(ele, invoiceDetail.response[ele?.id], null, null),
            type: ele.type
          });
        }
      });
    }
    let data = { custom_fields };
    actionExportInvoice(id, data);
  };

  handleDropDown = () => {
    this.setState(prevState => ({
      actionDropdown: !prevState.actionDropdown
    }));
  };

  handleCustomInvoiceItemsTable = (details) => {
    const { profile } = this.props;
    const array = details?.printTemplateData?.itemsList?.map(e => `<tr class="second_table_row">
        <td style="width: 30%; text-align: start;">${e.description ? `${e.name} - ${e.description}` : `${e.name}`}</td>
        <td style="width: 5%; text-align: center !important;">${e.quantity}</td>
        <td style="width: 12%; text-align: end;">${`${details.printTemplateData?.currency}${parseFloat(e.price)
          .toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
        </td>
        <td style="width: 5%; text-align: center !important;">${e.uom || 'EACH'}</td>
        <td style="width: 12%; text-align: end;">${details?.settings?.taxLevel === '2'
          ? `${details.printTemplateData?.currency}
            ${parseFloat(Math.floor(e.quantity * Number(profile?.price_adjusted ? e.price_adjust : e.price)))
              .toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
          : `${details.printTemplateData?.currency}
            ${parseFloat(getItemAmount(e, profile?.price_adjusted))
              .toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
        </td>
        <td style="width: 12%; text-align: end;">${e.price_adjust && profile.price_adjusted
          ? `${details.printTemplateData?.currency}${parseFloat(e.price_adjust)
            .toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
          : '-'}
        </td>
        <td style="width: 12%; text-align: end;">-</td>
        <td style="width: 12%; text-align: end;">${details?.settings?.taxLevel === '2'
          ? `${details.printTemplateData?.currency}
            ${parseFloat(Math.floor(e.quantity * Number(profile?.price_adjusted ? e.price_adjust : e.price)))
              .toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
          : `${details.printTemplateData?.currency}
            ${parseFloat(Math.floor(Number(getItemAmount(e, profile?.price_adjusted)) + Number(getTaxAmount(e, profile.price_adjusted))))
              .toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
        </td>
      </tr>`);
    return array;
  };

  handleCustomInvoiceAccountsTable = () => {
    const { invoiceSchema, invoiceDetail, profile } = this.props;
    const account = invoiceSchema?.payment_schema?.schema?.fields?.find(e => e.title.toLowerCase() === 'account');
    if (account?.id) {
      const array = invoiceDetail?.payments?.map(e => `<tr>
          <td style="width: 80%; text-align: start">${e?.other_info?.payment_response?.[account?.id]}</td>
          <td style="text-align: end !important">${profile?.airport_settings?.currency}${e.amount}</td>
        </tr>`);
      return array;
    } return `<tr>
          <td style="width: 80%; text-align: start">-</td>
          <td style="text-align: end !important">-</td>
        </tr>`;
  };

  checkBodyTagInTemplate = (htmlString) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    const bodyTagExists = tempDiv.getElementsByClassName('template');
    return bodyTagExists.length > 0;
  };


  render() {
    const { profile, invoiceDetail, history, invoiceSchema } = this.props;
    const { loadingStatus, actionDropdown } = this.state;
    let totalAmount = 0.00;
    let amountDue = 0.00;
    let discountAmount = 0.00;
    let creditAmount = 0.00;
    if (invoiceDetail?.id) {
      let amount = getTotalAmount(invoiceDetail.items, profile?.price_adjusted);
      discountAmount = parseFloat(invoiceDetail?.discount) || 0;
      creditAmount = parseFloat(invoiceDetail?.credit) || 0;
      amount -= discountAmount;
      amount += creditAmount;
      totalAmount = amount.toString().includes('.') ? amount : `${amount}.00`;
      amountDue = parseFloat(parseFloat(amount) - parseFloat(getTotalPaymentAmount(invoiceDetail?.payments))).toFixed(2);
      amountDue = amountDue.toString().includes('.') ? amountDue : `${amountDue}.00`;
    }
    let amountPaid = 0.00;
    if (invoiceDetail?.payments?.length > 0) {
      invoiceDetail.payments.forEach((payment) => {
        amountPaid += Number(payment?.amount);
      });
    }
    const payment_method = {
      'cash': 'Cash',
      'cheque': 'Cheque',
      'paypal': 'PayPal',
      'bank_account': 'Bank Account',
      'other': 'Other',
      'credit_card': 'Credit Card',
      'Money Order': 'Money Order'
    };
    if (invoiceDetail && Object.keys(invoiceDetail).length) {
      let tempItems = invoiceDetail?.items;
      if (invoiceDetail?.settings?.taxLevel === '2') {
        const taxItem = {
          name: 'Sales Tax',
          quantity: '1',
          price: getallTaxAmount(tempItems, profile?.price_adjusted),
          price_adjust: profile?.price_adjusted ? getallTaxAmount(tempItems, profile?.price_adjusted) : '0.00',
          uom: 'TAX',
          tax: []
        };
        tempItems = [...tempItems, taxItem];
      }
      const isFeeItemsAvailable = invoiceDetail?.items?.some(e => e.fee?.length > 0);
      if (isFeeItemsAvailable) {
      const feeItem = {
        name: 'Fee',
        quantity: '1',
        price: getallFeeAmount(invoiceDetail?.items, profile?.price_adjusted),
        price_adjust: profile?.price_adjusted ? getallFeeAmount(invoiceDetail?.items, profile?.price_adjusted) : '0.00',
        uom: 'FEE',
        tax: []
      };
      tempItems = [...tempItems, feeItem];
    }
    invoiceDetail.printTemplateData = {
      createdDate: renderInfoForType({ type: 'datetime' }, invoiceDetail.created_at, null, null),
      invoiceDate: renderInfoForType({ type: 'date' }, invoiceDetail.invoice_date, null, null),
      paymentDueDate: renderInfoForType({ type: 'date' }, invoiceDetail.payment_due, null, null),
      totalAmountDue: `${profile.urls.currency}${parseFloat(amountDue)
        .toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
      amountPaid: `${profile.urls.currency}${amountPaid.toString().includes('.') ? amountPaid : `${amountPaid}.00`}`,
      logo: profile?.portal_airport?.logo,
      currency: profile?.urls?.currency || '$',
      airportAddress: profile?.portal_airport?.airport_settings?.address,
      scissors: scissorIcon,
      itemsList: tempItems
    };
  }
    const getPrintView = () => '@page { size: auto; }';
    return (
      <>
        <div className={styles.sectionWrapper}>
          <Loading loadingStatus={loadingStatus} />
          <SectionHeader
            icon={icon}
            translationID="invoices.title.details"
            defaultTitle="Invoice Details"
          >

              <div className={styles.detailHeader}>
                <span
                    className={styles.actionDropBtn}
                    onClick={() => this.handleDropDown()}
                  >
                    <FormattedMessage
                      id="workorders.detail.actionBtn"
                      defaultMessage="Actions"
                    />
                </span>
                {actionDropdown
                  && invoiceDetail
                  && Object.keys(invoiceDetail).length > 0 && (
                    <ul
                      className={`${styles.dropdown} ${
                        actionDropdown ? styles.open : ''
                      }`}
                    >
                      {invoiceSchema?.custom_print_template && (
                        <li className={styles.item}>
                          <ReactToPrint
                            style={{ display: 'block', width: '100px', fontSize: '15px' }}
                            trigger={() => (
                              <span
                              translationID="workorders.detail.pdfBnt"
                              defaultText="Print"
                              action="secondary"
                            >
                            <FormattedMessage
                              id="workorders.detail"
                              defaultMessage=" Custom Print View"
                            />
                              </span>
                            )}
                            content={() => this.printCustomTemplateRef2.current}
                            documentTitle={`${profile?.portal_airport?.name} (${profile?.portal_airport?.code}) - ${invoiceDetail?.order_number}`}
                          />
                          <div style={{ display: 'none' }}>
                            <div ref={this.printCustomTemplateRef2}>
                              <style>{getPrintView()} </style>
                              <span
                                // eslint-disable-next-line react/no-danger, no-eval, prefer-template
                                dangerouslySetInnerHTML={{ __html: eval('`'
                                  + invoiceSchema?.custom_print_template + '`') }} />
                            </div>
                          </div>
                        </li>
                      )}
                    </ul>
                )}
              {profile && profile?.portal_airport && profile.portal_airport?.airport_settings
                && (profile.portal_airport.airport_settings?.stripe_account || (
                  profile.portal_airport.airport_settings?.stripe_key_type === 'individual'
                  && profile.portal_airport.airport_settings?.stripe_public_key !== undefined
                  && profile.portal_airport.airport_settings?.stripe_public_key !== null
              )) && invoiceDetail && invoiceDetail.status !== 2&& invoiceDetail?.payment_type !== 0 && (
                  <Button
                    onClick={() => history.push({
                        pathname: `/invoice/${invoiceDetail.order_number}/pay`,
                        state: { amount: amountDue }
                      })
                    }
                    translationID="invoices.payment.title"
                    defaultText="Pay this Invoice"
                  />
                )}
              </div>
          </SectionHeader>
        </div>
        <div className={styles.headWrapper}>
          <HeaderBack
            translationID="inspections.new.prev"
            translationDefault="Back"
            backRoute="/invoice"
          />
        </div>
        <div className="container">
          {invoiceDetail && Object.keys(invoiceDetail).length > 0 && (
          <div className={styles.DetailsWrapper}>
            <div className={styles.firstColumn}>
              <Panel
                containerClasses={styles.mainPanel}
                title={`Invoice #${invoiceDetail.order_number}`}
              >
                <div className={styles.requestInfo}>
                  <div className={styles.infoTable}>
                    <div className={styles.infoRow}>
                      <span className={styles.title}>
                        <FormattedMessage
                          id="invoice.details.status"
                          defaultMessage="Status"
                        />
                      </span>
                      <span className={styles.status}>{this.options[invoiceDetail.status] && this.options[invoiceDetail.status].name}</span>
                    </div>
                    <div className={styles.infoRow}>
                      <span className={styles.title}>
                        <FormattedMessage
                          id="invoice.details.customer"
                          defaultMessage="Customer"
                        />
                      </span>
                      <span className={styles.rowContent}>{invoiceDetail.customer && invoiceDetail.customer.name}</span>
                    </div>
                    <div className={styles.infoRow}>
                      <span className={styles.title}>
                        <FormattedMessage
                          id="invoice.details.amount_due"
                          defaultMessage="Amount Due"
                        />
                      </span>
                      <span className={styles.rowContent}>
                        <NumberFormat displayType="text"
                          value={(getTotalAmount(invoiceDetail.items, profile?.price_adjusted).toString()).includes('.')
                            ? (getTotalAmount(invoiceDetail.items, profile?.price_adjusted))
                            : `${getTotalAmount(invoiceDetail.items, profile?.price_adjusted)}.00`}
                          thousandSeparator prefix="$"
                        />
                      </span>
                    </div>
                    <div className={styles.infoRow}>
                      <span className={styles.title}>
                        <FormattedMessage
                          id="invoice.details.due_on"
                          defaultMessage="Due On"
                        />
                      </span>
                      <span className={styles.rowContent}>
                        {moment(invoiceDetail.payment_due).format('DD MMMM YYYY')}
                      </span>
                    </div>
                    <div className={styles.infoRow}>
                      <span className={styles.title}>
                        <FormattedMessage
                          id="invoice.details.invoice_created"
                          defaultMessage="Invoice created"
                        />
                      </span>
                      <span className={styles.rowContent}>
                      {moment(invoiceDetail.created_at).format('DD MMMM YYYY')}
                      </span>
                    </div>
                  </div>
                </div>
              </Panel>
            </div>
            <div className={styles.secondColumn}>
              <div className={styles.secondColumnHeader}>
                <div className={styles.leftHeader}>
                  <div className={styles.headerItem}>
                    <span className={styles.btnText} onClick={() => this.handleExportPDF(invoiceDetail.id)}>
                      {' '}
                      <FormattedMessage
                        id="invoices.details.export_as_pdf"
                        defaultMessage="Export as PDF"
                      />
                    </span>
                  </div>
                  <div className={styles.headerItem}>
                    <span>
                      <Print />
                    </span>
                    {this.checkBodyTagInTemplate(invoiceSchema?.custom_print_template) ? (
                      <>
                        <ReactToPrint
                          style={{ display: 'block', width: '100px', fontSize: '15px' }}
                          trigger={() => (
                            <span
                            translationID="workorders.detail.pdfBnt"
                            defaultText="Print"
                            action="secondary"
                          >
                          <FormattedMessage
                            id="workorders.detail"
                            defaultMessage=" Custom Print View"
                          />
                            </span>
                          )}
                          content={() => this.printCustomTemplateRef.current}
                          documentTitle={`${profile?.portal_airport?.name} (${profile?.portal_airport?.code}) - ${invoiceDetail?.order_number}`}
                        />
                        <div style={{ display: 'none' }}>
                          <div ref={this.printCustomTemplateRef} style={{ border: '1px solid #fff' }}>
                            <style>{getPrintView()} </style>
                            <span
                            className="m-0 p-0"
                              // eslint-disable-next-line react/no-danger, no-eval, prefer-template
                              dangerouslySetInnerHTML={{ __html: eval('`'
                                + invoiceSchema?.custom_print_template + '`') }} />
                          </div>
                        </div>
                      </>
                      ):(
                      <span
                        className={styles.btnText}
                        onClick={() => this.handleExportPDF(invoiceDetail.id)}
                        onKeyPress={() => this.handleExportPDF(invoiceDetail.id)}
                        role="button" tabIndex={0}
                      >
                        <FormattedMessage
                          id="invoices.details.print"
                          defaultMessage="Print"
                        />
                      </span>)}
                  </div>
                </div>
              </div>
              <div className={styles.summaryWrapper}>
                <div className={styles.summaryImg}>
                  <div className={styles.summaryImgWrapper}>
                    <img
                      src={profile.portal_airport.logo}
                      height="153px"
                      width="153px"
                      alt="airport logo"
                    />
                  </div>
                </div>
                <div className={styles.summaryDetails}>
                  <div className={styles.invoiceTitle}>
                    <FormattedMessage id="invoice.title" defaultMessage="Invoice" />
                  </div>
                  <div className={styles.invoiceDescription}>
                    {invoiceDetail.summary}
                  </div>
                  <div className={styles.airportName}>
                    {profile.portal_airport.name}
                  </div>
                </div>
              </div>
              <div className={styles.billDetailsWrapper}>
                <div className={styles.billDetail1}>
                  <div className={styles.billTo}>
                    <span>
                      <FormattedMessage
                        id="invoices.details.bill_to"
                        defaultMessage="Bill to"
                      />
                    </span>
                  </div>
                  <div className={styles.airportName}>
                    <span>{profile.portal_airport.name}</span>
                  </div>
                  <div className={styles.custName}>
                    <span>{invoiceDetail.customer && invoiceDetail.customer.name}</span>
                  </div>
                  <div className={styles.airportAddress}>
                    <span>
                      {invoiceDetail.customer && invoiceDetail.customer.address}
                      <br />
                      {' '}
                      {invoiceDetail.customer && invoiceDetail.customer.phone?.length > 10 ? invoiceDetail.customer.phone : ''}
                    </span>
                  </div>
                </div>
                <div className={styles.billDetail2}>
                  <div className={styles.invoiceNumber}>
                    <div className={styles.invoiceDetailsTitle}>
                      <FormattedMessage
                        id="invoices.details.invoice_number"
                        defaultMessage="Invoice Number"
                      />:
                    </div>
                    {invoiceDetail?.po_so_number
                    && <div className={styles.invoiceDetailsTitle}>
                        <FormattedMessage
                          id="invoices.details.invoice_po_number"
                          defaultMessage="P.O. Number"
                        />
                        :
                       </div>
                    }
                    <div className={styles.invoiceDetailsTitle}>
                      <FormattedMessage
                        id="invoices.details.invoice_date"
                        defaultMessage="Invoice Date"
                      />:
                    </div>
                    <div className={styles.invoiceDetailsTitle}>
                      <FormattedMessage
                        id="invoices.details.payment_due"
                        defaultMessage="Payment Due"
                      />:
                    </div>
                    <div className={styles.invoiceDetailsTitle}>
                      <FormattedMessage
                        id="invoices.details.amount_due"
                        defaultMessage="Amount Due (USD)"
                      />
                      :
                    </div>
                  </div>
                  <div className={styles.invoiceDate}>
                    <div className={styles.invoiceDeatailsValue}>
                    {invoiceDetail.order_number}
                    </div>
                    {invoiceDetail?.po_so_number
                      && <div className={styles.invoiceDeatailsValue}>
                          {invoiceDetail?.po_so_number}
                         </div>
                      }
                    <div className={styles.invoiceDeatailsValue}>
                      {invoiceDetail.invoice_date && moment(invoiceDetail.invoice_date).format('DD MMMM YYYY')}
                    </div>
                    <div className={styles.invoiceDeatailsValue}>
                      {invoiceDetail.payment_due && moment(invoiceDetail.payment_due).format('DD MMMM YYYY')}
                    </div>
                    <div className={styles.invoiceDeatailsValueDark}>
                      <NumberFormat displayType="text"
                        value={amountDue}
                        thousandSeparator
                        decimalScale={profile?.portal_airport?.airport_settings?.decimal_precision || 2}
                        fixedDecimalScale
                        prefix={profile?.urls?.currency || '$'}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <table className={tableStyles.table}>
                <thead className={styles.tableHeader}>
                  <th>
                    <FormattedMessage
                      id="invoices.details.product"
                      defaultMessage="Product"
                    />
                  </th>
                  <th>
                    <FormattedMessage
                      id="invoices.details.product_description"
                      defaultMessage="Description"
                    />
                  </th>
                  <th>
                    <FormattedMessage
                      id="invoices.create.quantity"
                      defaultMessage="Quantity"
                    />
                  </th>
                  <th>
                    <FormattedMessage
                      id="invoices.create.price"
                      defaultMessage="Price"
                    />
                  </th>
                  {profile?.price_adjusted && (
                    <th>
                      <FormattedMessage
                        id="invoices.create.adjusted"
                        defaultMessage="Adjusted"
                      />
                    </th>)}
                  <th>
                    <FormattedMessage
                      id="invoices.create.amount"
                      defaultMessage="Amount"
                    />
                  </th>
                </thead>
                <tbody>
                {invoiceDetail.items.map(item => (
                  <tr key={item?.id}>
                    <td>{item.name}</td>
                    <td>{item.description}</td>
                    <td>{item.quantity}</td>
                    <td>
                      <NumberFormat displayType="text"
                        value={item.price}
                        thousandSeparator
                        decimalScale={profile?.portal_airport?.airport_settings?.decimal_precision || 2}
                        fixedDecimalScale
                        prefix={profile?.urls?.currency || '$'}
                      />
                    </td>
                    {profile?.price_adjusted && (
                        <td>
                          <NumberFormat
                            displayType="text"
                            value={item?.price_adjust}
                            thousandSeparator
                            decimalScale={profile?.portal_airport?.airport_settings?.decimal_precision || 2}
                            fixedDecimalScale
                            prefix={profile?.urls?.currency || '$'}
                          />
                        </td>)}
                    <td>
                      <NumberFormat displayType="text"
                        value={getItemAmount(item, profile?.price_adjusted)}
                        thousandSeparator
                        decimalScale={profile?.portal_airport?.airport_settings?.decimal_precision || 2}
                        fixedDecimalScale
                        prefix={profile?.urls?.currency || '$'}
                      />
                    </td>
                  </tr>
                ))}
                <tr>
                  <td colSpan="7" rowSpan="3">
                <div className={styles.itemsFooterWrapper}>
                <div className={styles.itemsFooter}>
                  <div>
                    <p className={styles.totalTax}>
                      <FormattedMessage
                        id="invoices.create.sub_total"
                        defaultMessage="Sub total"
                      />
                    </p>
                    <p className={styles.totalTax}>
                      <FormattedMessage
                        id="invoices.create.tax"
                        defaultMessage="Tax"
                      />
                    </p>
                    <p className={styles.totalTax}>
                      <FormattedMessage
                        id="invoices.create.fee"
                        defaultMessage="Fee"
                      />
                    </p>
                    <p className={styles.totalTax}>
                      <FormattedMessage
                        id="invoices.create.discount"
                        defaultMessage="Discount"
                      />
                    </p>
                    <p className={styles.totalTax}>
                      <FormattedMessage
                        id="invoices.create.total"
                        defaultMessage="Total"
                      />
                    </p>
                  </div>
                  <div>
                    <p className={styles.totalTax}>
                      <NumberFormat displayType="text"
                        value={getallPrices(invoiceDetail.items, profile?.price_adjusted)}
                        thousandSeparator
                        decimalScale={profile?.portal_airport?.airport_settings?.decimal_precision || 2}
                        fixedDecimalScale
                        prefix={profile?.urls?.currency || '$'}
                      />
                    </p>
                    <p className={styles.totalTax}>
                      <NumberFormat displayType="text"
                        value={getallTaxAmount(invoiceDetail.items, profile?.price_adjusted)}
                        thousandSeparator
                        decimalScale={profile?.portal_airport?.airport_settings?.decimal_precision || 2}
                        fixedDecimalScale
                        prefix={profile?.urls?.currency || '$'}
                      />
                    </p>
                    <p className={styles.totalTax}>
                      <NumberFormat displayType="text"
                        value={getallFeeAmount(invoiceDetail.items)}
                        thousandSeparator
                        decimalScale={profile?.portal_airport?.airport_settings?.decimal_precision || 2}
                        fixedDecimalScale
                        prefix={profile?.urls?.currency || '$'}
                      />
                    </p>
                    <p className={styles.totalTax}>
                      <NumberFormat
                        displayType="text"
                        value={discountAmount}
                        thousandSeparator
                        decimalScale={profile?.portal_airport?.airport_settings?.decimal_precision || 2}
                        fixedDecimalScale
                        prefix={profile?.urls?.currency || '$'}
                      />
                    </p>
                    <p className={styles.totalWrap}>
                      <NumberFormat
                        displayType="text"
                        value={totalAmount}
                        thousandSeparator
                        decimalScale={profile?.portal_airport?.airport_settings?.decimal_precision || 2}
                        fixedDecimalScale
                        prefix={profile?.urls?.currency || '$'}
                      />
                    </p>
                  </div>
                </div>
                </div>
                  </td>
                </tr>
                </tbody>
              </table>
              <table className={tableStyles.table}>
                  <tbody>
                    <tr>
                      <td colSpan="6" rowSpan="3">
                        <div className={styles.itemsFooterWrapper}>
                          <div className={styles.itemsFooter}>
                            <div>
                              {invoiceDetail?.payments?.map(payment => (
                                <p className={styles.totalTax}>
                                  {`Payment on ${renderInfoForType({ 'type': 'date' }, payment.payment_date, null, null)}
                                  using a ${payment_method?.[payment?.payment_method]}`}
                                </p>
                              ))}
                              <p className={styles.totalWrap}>
                                <FormattedMessage
                                  id="invoices.create.amount_due"
                                  defaultMessage="Amount due (USD)"
                                />
                              </p>
                            </div>
                            <div>
                              {invoiceDetail?.payments?.map(payment => (
                                <p className={styles.totalTax}>
                                  <NumberFormat
                                    displayType="text"
                                    value={payment?.amount}
                                    thousandSeparator
                                    decimalScale={profile?.portal_airport?.airport_settings?.decimal_precision || 2}
                                    fixedDecimalScale
                                    prefix={
                                      profile.portal_airport.airport_settings.currency || '$'
                                    }
                                  />
                                </p>
                              ))}
                              <p className={styles.totalWrap}>
                                <NumberFormat
                                  displayType="text"
                                  value={amountDue}
                                  thousandSeparator
                                  decimalScale={profile?.portal_airport?.airport_settings?.decimal_precision || 2}
                                  fixedDecimalScale
                                  prefix={
                                    profile.portal_airport.airport_settings.currency || '$'
                                  }
                                />
                              </p>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
              </table>
              <div className={styles.invoiceNotes}>
              <div className={styles.invoiceDetailsTitle}>
                      <FormattedMessage
                        id="invoices.details.notes"
                        defaultMessage="Notes/Terms"
                      />:
              </div>
                <span style={{ color: '#8C9EA7', marginLeft: '10px' }}>
                  {invoiceDetail.description}
                </span>
              </div>
              <div className={styles.custom_fields}>
                {invoiceDetail?.schema?.schema?.fields?.length > 0 && invoiceDetail?.response
                  &&invoiceDetail?.schema?.schema?.fields?.map(customData => invoiceDetail?.response[customData?.id] && (
                  <div className={`${styles.infoRow} ${styles.custom_right}`} style={{ width: '50%' }}>
                      <div className={styles.halfRow}>
                          <span className={styles.title}>
                              {customData?.title}
                          </span>
                          <span className={styles.rowContent}>
                          {customData.type === 'attachments' && invoiceDetail?.response[customData.id]?.length>0
                                ? <span className={styles.photoicon}>
                                  {invoiceDetail?.response[customData.id]?.map(e => ((e.type || e.content_type).includes('image')
                                  ? (<img
                                    style={{ height: '100px', objectFit: 'contain' }}
                                      src={e?.url || e?.file_name} alt={'attachment'} />):(
                                        <a href={e.url} target="_blank" rel="noopener noreferrer">
                                          {e.file_name}
                                        </a>
                                      )))}
                                  </span>
                                : renderInfoForType(customData, invoiceDetail?.response[customData.id], invoiceDetail?.schema, true)
                              }
                          </span>
                      </div>
                  </div>))}
              </div>
            </div>
          </div>
          )}
        </div>
      </>
    );
  }
}

InvoiceDetails.propTypes = {
  match: PropTypes.shape({}).isRequired,
  actionGetInvoice: PropTypes.func.isRequired,
  actionExportInvoice: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  profile: state.auth.profile,
  invoiceDetail: state.invoice.invoiceDetail,
  invoiceSchema: state.invoice.invoiceSchema
});

const mapDispatchToProps = dispatch => ({
  actionGetInvoice: (id) => {
    dispatch(fetchInvoiceDetail(id));
  },
  actionExportInvoice: (id, data) => {
    dispatch(exportInvoice(id, data));
  },
  actionGetSchema: () => {
    dispatch(invoiceGetSchema());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceDetails);
